// Centralized site-level SEO configuration.
// The real site origin is read from the VITE_SITE_URL environment variable.

export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://cssbuybr.homes';

export const SITE_NAME = 'CSSBuy Spreadsheet Resource';

// Authoritative favicon (provided via project settings / embed_code).
export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

// Open Graph / social share image for the homepage (existing site asset).
export const HOME_OG_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20vibrant%20editorial%20flatlay%20of%20assorted%20premium%20streetwear%20fashion%20items%20including%20colorful%20sneakers%20hoodies%20sunglasses%20and%20accessories%20arranged%20artfully%20on%20a%20warm%20textured%20backdrop%2C%20rich%20saturated%20colors%2C%20soft%20directional%20lighting%2C%20high%20end%20fashion%20magazine%20photography%20style%2C%20dynamic%20composition&width=1600&height=900&seq=hero-bg-02&orientation=landscape&nocache=true';